(function () {
  'use strict';

  angular.module('PrintixProviderTenant', [])

    .constant('RequiredTenantModelProperties', [
      'hostingDomains',
      'name'
    ])

    .constant('DISCOVERY_TASKS', {
      DISCOVER_ENVIRONMENT: 'DISCOVER_ENVIRONMENT'
    })

    .constant('PRINT_QUEUE_ID_SIGN_PLACEMENT', {
      SIGNID_AFTER: 'SIGNID_AFTER',
      SIGNID_BEFORE: 'SIGNID_BEFORE',
      SIGNID_HIDDEN: 'SIGNID_HIDDEN'
    })

    .constant('TenantEmbeddedProperties', '?embed=PUSHER_CLIENT_INFO,progressingTasks,toDos,billingData,billingStatus,identityProviders,wsCountPerOs')

    .factory('TenantModel', ['$rootScope', 'Utils', '$filter', 'RequiredTenantModelProperties', 'PrintixErrorConstants',
      '$location', 'SETUP_ASSISTANT', 'URLS', '$http', '$q', 'TenantEmbeddedProperties',
      function ($rootScope, Utils, $filter, RequiredTenantModelProperties, PrintixErrorConstants, $location, SETUP_ASSISTANT,
        URLS, $http, $q, TenantEmbeddedProperties) {
        return function (tenantDataReceived) {
          // START VARIABLES**************************************************************************************/
          const TenantModel = {};
          const TenantModelPrivate = {};
          // END VARIABLES****************************************************************************************/

          // START init*******************************************************************************************/
          TenantModel.init = function (tenantDataReceived) {
            if (Utils.objectPropertiesCheck(tenantDataReceived, RequiredTenantModelProperties)) {
              TenantModel.info = angular.copy(tenantDataReceived);
              TenantModel.options = {
                isSelected: false,
                setupAssistantIsClosed: false
              };
              TenantModel.customProperties = {};
              TenantModelPrivate.normalizeLinks();
            } else {
              throw 'TenantModel: tenantDataReceived is not valid';
            }
          };
          // END init*********************************************************************************************/

          // START TenantModel************************************************************************************/
          TenantModel.isPowerPDFEnabled = function() {
            return !!TenantModel.info._embedded.productsAndFeatures.products?.POWER_PDF?.enabled;
          }

          TenantModel.isPrintixEnabled = function() {
            return  !!(TenantModel.info._embedded.productsAndFeatures.products?.ZERO?.enabled ||
                       TenantModel.info._embedded.productsAndFeatures.products?.FREEDOM?.enabled ||
                       TenantModel.info._embedded.productsAndFeatures.products?.EXPERIMENTAL?.enabled)
          }

          TenantModel.isPowerPDFOnly = function() {
            return this.isPowerPDFEnabled() && !this.isPrintixEnabled();
          }

          TenantModel.isPrintixOnly = function() {
            return !this.isPowerPDFEnabled() && this.isPrintixEnabled();
          }

          TenantModelPrivate.normalizeLinks = function () {
            angular.forEach(TenantModel.info._links, function (link, index) {
              if (angular.isObject(link) && !angular.isArray(link)) {
                const linkClean = link.href.split('?')[0];
                TenantModel.info._links[index].href = linkClean;
              }
            });
            const selfHrefSplit = TenantModel.info._links.self.href.split('/');
            TenantModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
          };

          TenantModelPrivate.replaceInfo = function (embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
            if (!TenantModel.info._embedded) {
              TenantModel.info._embedded = {};
            }
            if (embeddedKey) {
              TenantModel.info._embedded[embeddedKey] = angular.copy(data);
            } else {
              const embedded = angular.copy(TenantModel.info._embedded);
              const links = angular.copy(TenantModel.info._links);
              TenantModel.info = angular.copy(data);
              if (!doNotReplaceEmbeddedAndLinks) {
                TenantModel.info._embedded = embedded;
                TenantModel.info._links = links;
              }
              TenantModelPrivate.normalizeLinks();
            }
          };

          TenantModelPrivate.getProgressingTask = function (url) {
            if (url) {
              const deferred = $q.defer();
              $http.get(url).then(function (response) {
                if (!TenantModel.info._embedded.progressingTasks) {
                  TenantModel.info._embedded.progressingTasks = [];
                }
                TenantModel.info._embedded.progressingTasks.add(angular.copy(response.data));
                deferred.resolve(response);
              }, function (response) {
                deferred.reject(response);
              });
              return deferred.promise;
            } else {
              throw 'TenantModelPrivate.getProgressingTask: url is missing';
            }
          };

          TenantModel.showTrialExpireNotification = function () {
            if (((TenantModel.info._embedded.billingData &&
                  (TenantModel.info._embedded.billingData.billingMethod !== 'DRAFT_USAGE_PRINTING_USERS_MONTHLY' &&
                    TenantModel.info._embedded.billingData.billingMethod !== 'AGGREGATE_PRINTING_USERS_MONTHLY' &&
                    TenantModel.info._embedded.billingData.billingMethod !== 'DRAFT_AGGREGATE_PRINTING_USERS_MONTHLY')) &&
                (!TenantModel.info._embedded.billingData.creditCardLast4 &&
                  $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'days') < 32)) ||
              TenantModel.info.deactivatedTime) {
              return true;
            } else {
              return false;
            }
          };

          TenantModel.isTrialExpired = function () {
            if ($filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'milliseconds') < 0 ||
              TenantModel.info.deactivatedTime) {
              return true;
            } else {
              return false;
            }
          };

          TenantModel.getTrialExpireNotificationText = function () {
            if (TenantModel.showTrialExpireNotification()) {
              switch (true) {
                case TenantModel.info.deactivatedTime != null:
                {
                  var translation = $filter('translate')('YourAccountHasExpired');
                  return $filter('stringular')(translation, $rootScope.currentOEM);
                }
                case $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'days') > 14:
                {
                  const trialExpireDate = $filter('date')(TenantModel.info._embedded.billingStatus.trialEndTime, 'yyyy-MM-dd');
                  var translation = $filter('translate')('TrialEnds');
                  return $filter('stringular')(translation, trialExpireDate);
                }
                case $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'days') < 15 &&
                $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'days') > 1:
                {
                  const trialLeftInDays = $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'days');
                  var translation = $filter('translate')('TrialEndsInDays');
                  return $filter('stringular')(translation, trialLeftInDays);
                }
                case $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'days') === 1 ||
                $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'milliseconds') > 0:
                {
                  const differenceInMilliseconds = $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'milliseconds');
                  const differenceFormated = $filter('amDurationFormat')(differenceInMilliseconds, 'milliseconds');
                  var translation = $filter('translate')('TrialEndsIn');
                  return $filter('stringular')(translation, differenceFormated);
                }
                case $filter('amDifference')(TenantModel.info._embedded.billingStatus.trialEndTime, null, 'milliseconds') < 0:
                {
                  var translation = $filter('translate')('YourAccountHasExpired');
                  return $filter('stringular')(translation, $rootScope.currentOEM);
                }
                default:
                {
                  throw 'TenantModel.getTrialExpireNotificationText: default case';
                }
              }
            } else {
              throw 'TenantModel.getTrialExpireNotificationText: TenantModel.showTrialExpireNotification() returned false';
            }
          };

          TenantModel.manageProgressingTasks = function (progressReceived) {
            if (progressReceived) {
              if (TenantModel.info._embedded.progressingTasks && TenantModel.info._embedded.progressingTasks.length > 0) {
                const taskFound = TenantModel.info._embedded.progressingTasks.findElement({
                  _links: {
                    self: {
                      href: progressReceived.task
                    }
                  }
                });
                if (taskFound) {
                  const progressFound = taskFound._embedded.progress.findElement({
                    subject: progressReceived.subject
                  });
                  if (progressFound) {
                    if (progressReceived.current > progressFound.current) {
                      progressFound.current = angular.copy(progressReceived.current);
                    }
                  } else {
                    taskFound._embedded.progress.add(progressReceived);
                  }
                } else {
                  TenantModelPrivate.getProgressingTask(progressReceived.task);
                }
              } else {
                TenantModelPrivate.getProgressingTask(progressReceived.task);
              }
            } else {
              throw 'TenantModel.manageProgressingTasks: progress is missing';
            }
          };

          TenantModel.checkToDoList = function () {
            if (SETUP_ASSISTANT &&
              TenantModel.info._embedded.toDos &&
              $location.path() !== URLS.SETUP_ASSISTANT &&
              $location.path() !== URLS.SUPPORT) {
              if ((TenantModel.info._embedded.toDos.findElement({
                action: SETUP_ASSISTANT.SHOW_INTRODUCTION
              }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.DOWNLOAD_CLIENT
                  }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.AWAIT_WORKSTATION
                  }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.AWAIT_INITIAL_DISCOVERY
                  }) ||
                  TenantModel.info._embedded.toDos.findElement({
                    action: SETUP_ASSISTANT.OPEN_DASHBOARD
                  })) &&
                !TenantModel.options.setupAssistantIsClosed) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          };

          TenantModel.inviteTechnician = function (data) {
            if (data) {
              return $http.post(TenantModel.info._links['px:userTasks'].href, data);
            } else {
              throw 'TenantModel.prototype.inviteTechnician : data is missing';
            }
          };

          TenantModel.testTenantAdConfig = function (urlParameters, credentialParameters) {
            if (urlParameters && credentialParameters && credentialParameters.userName && credentialParameters.password) {
              const data = 'adConfig=' + encodeURIComponent(JSON.stringify(urlParameters)) + '&username=' + credentialParameters.userName +
                '&password=' + credentialParameters.password;
              return $http.post(this.info._embedded.authenticationConfiguration._links['px:testAdConfig'].href, data, {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              });
            } else {
              throw 'TenantModel.prototype.testTenantAdConfig : urlParameters or credentialParameters are missing';
            }
          };

          TenantModel.refreshInfo = function (url, embeddedKey) {
            const deferred = $q.defer();
            if (url && embeddedKey) {
              $http.get(url).then(function (response) {
                TenantModelPrivate.replaceInfo(embeddedKey, response.data);
                deferred.resolve(response);
              }, function (response) {
                deferred.reject(response);
              });
            } else {
              // $http.get(TenantModel.info._links.self.href + TenantEmbeddedProperties).then(function(response) {
              $http.get(TenantModel.info._links.self.href).then(function (response) {
                TenantModelPrivate.replaceInfo(null, response.data, true);
                deferred.resolve(response);
              }, function (response) {
                deferred.reject(response);
              });
            }
            return deferred.promise;
          };

          TenantModel.removeToDoItem = function (todo) {
            if (todo && TenantModel.info._embedded.toDos && TenantModel.info._embedded.toDos.indexOf(todo) > -1) {
              const deferred = $q.defer();
              $http.delete(todo._links.self.href).then(function (response) {
                TenantModel.info._embedded.toDos.remove(todo);
                deferred.resolve(response);
              }, function (response) {
                deferred.reject(response);
              });
              return deferred.promise;
            } else {
              throw 'TenantModel.prototype.removeTodoItem : todo or tenant.info._embedded.toDos are missing';
            }
          };

          TenantModel.discoverEnvironment = function (workstation) {
            let data = null;
            if (workstation) {
              data = {
                workstation: workstation.info._links.self.href
              };
            }
            return $http.post(TenantModel.info._links['px:discoverEnvironment'].href, data);
          };

          TenantModel.changeBillingData = function (changedBillingData) {
            if (changedBillingData) {
              const patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.billingData, changedBillingData);
              if (patchObjectArray && patchObjectArray.length > 0) {
                const deferred = $q.defer();
                $http.patch(TenantModel.info._embedded.billingData._links.self.href, patchObjectArray).then(function (response) {
                  TenantModel.info._embedded.billingData = angular.copy(response.data);
                  deferred.resolve(response);
                }, function (response) {
                  deferred.reject(response);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw 'TenantModelPrivate.changeBillingData: changedBillingData is missing';
            }
          };

          TenantModel.sendStripeToken = function (token) {
            if (token) {
              const dataToSend = {
                stripeToken: token
              };
              const deferred = $q.defer();
              $http.post(TenantModel.info._embedded.billingData._links['px:stripeToken'].href, dataToSend).then(function (response) {
                TenantModel.refreshInfo(TenantModel.info._embedded.billingData._links.self.href, 'billingData').then(function () {
                  deferred.resolve(response);
                }, function (response) {
                  deferred.reject(response);
                });
              }, function (response) {
                deferred.reject(response);
              });
              return deferred.promise;
            } else {
              throw 'TenantModelPrivate.sendStripeToken: token is missing';
            }
          };

          TenantModel.getFeatureConfigInfo = function (urlKey) {
            if (urlKey && TenantModel.info._embedded.productsAndFeatures._links[urlKey] && TenantModel.info._embedded.productsAndFeatures._links[urlKey].href) {
              return $http.get(TenantModel.info._embedded.productsAndFeatures._links[urlKey].href);
            } else {
              throw 'TenantModel.getFeatureConfigInfo: urlKey or TenantModel.info._links[urlKey].href are missing';
            }
          };

          TenantModel.changeFeatureConfigInfo = function (urlKey, originalFeatureConfigInfo, changedFeatureConfigInfo) {
            if (urlKey && originalFeatureConfigInfo && changedFeatureConfigInfo && TenantModel.info._embedded.productsAndFeatures._links[urlKey]) {
              const patchObjectArray = Utils.getObjectsDifferencesForPatching(originalFeatureConfigInfo, changedFeatureConfigInfo);
              if (patchObjectArray && patchObjectArray.length > 0) {
                return $http.patch(TenantModel.info._embedded.productsAndFeatures._links[urlKey].href, patchObjectArray);
              } else {
                return $q.resolve();
              }
            } else {
              throw 'TenantModelPrivate.changeFeatureConfigInfo: url or originalFeatureConfigInfo or changedFeatureConfigInfo or TenantModel.info._embedded.productsAndFeatures._links[urlKey] are missing';
            }
          };

          TenantModel.changeFeaturesInfo = function (tenantChanged) {
            if (tenantChanged) {
              const patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.productsAndFeatures, tenantChanged.info._embedded.productsAndFeatures);
              angular.forEach(patchObjectArray, function (patchObject) {
                if (patchObject.path.indexOf('products') > -1) {
                  patchObjectArray.splice(patchObjectArray.indexOf(patchObject), 1);
                }
              });
              if (patchObjectArray && patchObjectArray.length > 0) {
                const deferred = $q.defer();
                $http.patch(TenantModel.info._embedded.productsAndFeatures._links.self.href, patchObjectArray).then(function (response) {
                  TenantModelPrivate.replaceInfo('productsAndFeatures', response.data);
                  deferred.resolve(response);
                }, function (response) {
                  deferred.reject(response);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw 'TenantModelPrivate.changeFeaturesInfo: tenantChanged is missing';
            }
          };

          TenantModel.updateDriverConfigName = function (driverConfigName, os, driverConfigId, printer, printQueue) {
            const objectToSend = {
              name: driverConfigName,
              sourceConfigurationId: driverConfigId,
              printerId: printer.info._links.self.href,
              operatingSystem: os.key,
              queueId: printQueue.info._links.self.href
            };
            return $http.post(TenantModel.info._links['px:driverConfigurations'].href, objectToSend);
          };

          TenantModel.manageDriverConfig = function (driverConfigName, os, workstation, printer, printQueue, sourceConfiguration, copySourceConfig) {
            if (driverConfigName && os && workstation && printer && printQueue) {
              const objectToSend = {
                name: driverConfigName,
                workstationId: workstation._links.self.href,
                printerId: printer.info._links.self.href,
                operatingSystem: os.key,
                queueId: printQueue.info._links.self.href
              };
              if (sourceConfiguration) {
                if (copySourceConfig) {
                  objectToSend.replaceSource = false;
                } else {
                  objectToSend.replaceSource = true;
                }
                objectToSend.sourceConfigurationId = sourceConfiguration._links.self.href;
              }
              return $http.post(TenantModel.info._links['px:driverConfigurations'].href, objectToSend);
            } else {
              throw 'TenantModel.createDriverConfig: driverProfileName or operatingSystem or workstation or printer are missing';
            }
          };
          // END TenantModel**************************************************************************************/

          // START SaveChanges************************************************************************************/
          TenantModel.saveAuthConfigChanges = function (tenantAuthConfigChanged) {
            if (tenantAuthConfigChanged) {
              const patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.authenticationConfiguration, tenantAuthConfigChanged);
              if (patchObjectArray && patchObjectArray.length > 0) {
                const deferred = $q.defer();
                $http.patch(TenantModel.info._embedded.authenticationConfiguration._links.self.href, patchObjectArray).then(function (response) {
                  TenantModelPrivate.replaceInfo('authenticationConfiguration', response.data);
                  deferred.resolve(response);
                }, function (response) {
                  deferred.reject(response);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw 'TenantModel.saveAuthConfigChanges: tenantAuthConfigChanged is missing';
            }
          };

          TenantModel.saveIdentityProvidersChanges = function (identityProvidersChanged) {
            if (identityProvidersChanged) {
              const patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.identityProviders, identityProvidersChanged);
              if (patchObjectArray && patchObjectArray.length > 0) {
                const deferred = $q.defer();
                $http.patch(TenantModel.info._embedded.identityProviders._links.self.href, patchObjectArray).then(function (response) {
                  TenantModelPrivate.replaceInfo('identityProviders', response.data);
                  deferred.resolve(response);
                }, function (response) {
                  deferred.reject(response);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw 'TenantModel.saveIdentityProvidersChanges: identityProvidersChanged is missing';
            }
          };

          TenantModel.saveGraphApiChanges = function (tenantGraphApiChanged) {
            if (tenantGraphApiChanged) {
              const patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info._embedded.graphApiSynchronization, tenantGraphApiChanged);
              if (patchObjectArray && patchObjectArray.length > 0) {
                const deferred = $q.defer();
                $http.patch(TenantModel.info._embedded.graphApiSynchronization._links.self.href, patchObjectArray).then(function (response) {
                  TenantModelPrivate.replaceInfo('graphApiSynchronization', response.data);
                  deferred.resolve(response);
                }, function (response) {
                  deferred.reject(response);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw 'TenantModel.saveGraphApiChanges: tenantGraphApiChanged is missing';
            }
          };

          TenantModel.saveChanges = function (tenantChanged) {
            if (tenantChanged) {
              const patchObjectArray = Utils.getObjectsDifferencesForPatching(TenantModel.info, tenantChanged.info);
              if (patchObjectArray && patchObjectArray.length > 0) {
                const deferred = $q.defer();
                $http.patch(TenantModel.info._links.self.href, patchObjectArray).then(function (response) {
                  TenantModelPrivate.replaceInfo(null, response.data);
                  deferred.resolve(response);
                }, function (response) {
                  deferred.reject(response);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw 'TenantModel.saveChanges: tenantChanged is missing';
            }
          };
          // END SaveChanges**************************************************************************************/

          // START CREATE*****************************************************************************************/
          TenantModel.init(tenantDataReceived);
          delete TenantModel.init;
          // END CREATE*******************************************************************************************/

          return TenantModel;
        };
      }
    ])

    .service('TenantListService', ['$rootScope', '$filter', 'EnvironmentService', 'Utils', 'TenantModel', '$location', 'URLS', '$injector',
      'API_VALUES', '$http', '$q', 'TenantEmbeddedProperties', 'USER_RIGHTS', '$ngBootbox',
      function ($rootScope, $filter, EnvironmentService, Utils, TenantModel, $location, URLS, $injector, API_VALUES, $http, $q, TenantEmbeddedProperties,
        USER_RIGHTS, $ngBootbox) {
        // START VARIABLES******************************************************************************************/
        const TenantsListModelPrivate = {};
        const tenantListServiceAsObject = this;
        let EventServiceEvents = null;
        TenantsListModelPrivate.currentTenantUrl = 'https://' + EnvironmentService.apiDomain + '/v1/tenants/' + $location.host() + TenantEmbeddedProperties;
        this.currentTenant = null;
        this.list = [];

        try {
          EventServiceEvents = $injector.get('EventServiceEvents');
        } catch (e) {

        }

        this.resolveCurrentTenant = function() {
          var deferred = $q.defer();
          $http.get(TenantsListModelPrivate.currentTenantUrl).then(function(response) {
            if (!tenantListServiceAsObject.currentTenant) {
              tenantListServiceAsObject.currentTenant = new TenantModel(response.data);
            }

            //add current user url to $rootScope for the Error handler
            if (tenantListServiceAsObject.currentTenant.info._links["px:currentuser"]) {
              console.log("Adding current user URL to $rootScope");
              $rootScope.currentUserUrl = tenantListServiceAsObject.currentTenant.info._links["px:currentuser"].href;
            }
            deferred.resolve(tenantListServiceAsObject.currentTenant);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };
        // END VARIABLES********************************************************************************************/

        // START INITIALISE AUTH MODULE*****************************************************************************/
        // END INITIALISE AUTH MODULE*******************************************************************************/

        // START CURRENT TENANT*************************************************************************************/
        TenantsListModelPrivate.getCurrentTenant = function () {
          const deferred = $q.defer();
          $http.get(TenantsListModelPrivate.currentTenantUrl).then(function (response) {
            tenantListServiceAsObject.currentTenant = new TenantModel(response.data);
            // add current user url to $rootScope for the Error handler
            if (tenantListServiceAsObject.currentTenant.info._links['px:currentuser']) {
              $rootScope.currentUserUrl = tenantListServiceAsObject.currentTenant.info._links['px:currentuser'].href;
            }
            if (tenantListServiceAsObject.currentTenant.checkToDoList()) {
              $location.path(URLS.SETUP_ASSISTANT);
            }
            deferred.resolve(response);
          }, function (response) {
            deferred.reject(response);
          });
          return deferred.promise;
        };
        // END CURRENT TENANT***************************************************************************************/

        // START EVENT LISTENERS************************************************************************************/
        TenantsListModelPrivate.startListeningAdminChannels = function () {
          $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TODO_REMOVED, function (name, data) {
            if (tenantListServiceAsObject.currentTenant &&
              tenantListServiceAsObject.currentTenant.info._embedded.toDos) {
              const todoFound = tenantListServiceAsObject.currentTenant.info._embedded.toDos.findElement({
                action: data.todo
              });
              if (todoFound) {
                tenantListServiceAsObject.currentTenant.info._embedded.toDos.remove(todoFound);
              }
            }
          });

          $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TASK_PROGRESS_ADMIN, function (name, data) {
            if (tenantListServiceAsObject.currentTenant) {
              tenantListServiceAsObject.currentTenant.manageProgressingTasks(data);
            }
          });

          $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.TENANT_UPDATED, function (name, data) {
            if (tenantListServiceAsObject.currentTenant) {
              tenantListServiceAsObject.currentTenant.refreshInfo();
            }
          });

          $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.BILLING_DATA_UPDATED, function (name, data) {
            if (tenantListServiceAsObject.currentTenant) {
              tenantListServiceAsObject.currentTenant.refreshInfo();
            }
          });

          $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.AUTH_CONFIG_UPDATED, function (name, data) {
            if (tenantListServiceAsObject.currentTenant) {
              tenantListServiceAsObject.currentTenant.refreshInfo();
            }
          });

          $rootScope.$on(EventServiceEvents.CHANNELS.SPECIFIC_USER.EVENTS.TASK_PROGRESS_USER, function (name, data) {
            if (tenantListServiceAsObject.currentTenant) {
              tenantListServiceAsObject.currentTenant.manageProgressingTasks(data);
            }
          });

          $rootScope.$on(EventServiceEvents.CHANNELS.SPECIFIC_USER.EVENTS.DISCOVERY_REPORT, function (name, data) {
            let translation = '';
            if (data.printersAdded.length > 0) {
              if (data.printersAdded.length === 1) {
                translation = $filter('stringular')($filter('translate')('FoundPrinter'), data.printersAdded.length);
              } else {
                translation = $filter('stringular')($filter('translate')('FoundPrinters'), data.printersAdded.length);
              }
            } else {
              translation = $filter('translate')('NoNewPrinters');
            }
            $ngBootbox.alert(translation);
          });
        };

        if (EventServiceEvents) {
          var watchCurrentUser = $rootScope.$watch(function () {
            return $rootScope.currentUser;
          }, function () {
            if ($rootScope.currentUser && $rootScope.currentUser.info &&
              $filter('contains')($rootScope.currentUser.info._embedded.permissions.permissions, USER_RIGHTS.ADMIN_LOGIN)) {
              TenantsListModelPrivate.startListeningAdminChannels();
              watchCurrentUser();
            }
          });
        }
        // END EVENT LISTENERS**************************************************************************************/

        // START INIT CURRENT TENANT********************************************************************************/
        TenantsListModelPrivate.getCurrentTenant();

        // for main menu items
        $rootScope.TenantListService = tenantListServiceAsObject;

        // if the location path changes - check the info._embedded.toDos
        $rootScope.$watch(function () {
          return $location.path();
        }, function () {
          if (tenantListServiceAsObject.currentTenant && tenantListServiceAsObject.currentTenant.checkToDoList()) {
            $location.path(URLS.SETUP_ASSISTANT);
          }
        });

        // if current tenant changed - check the info._embedded.toDos
        $rootScope.$watch(function () {
          return tenantListServiceAsObject.currentTenant;
        }, function () {
          if (tenantListServiceAsObject.currentTenant && tenantListServiceAsObject.currentTenant.checkToDoList()) {
            $location.path(URLS.SETUP_ASSISTANT);
          }
        }, true);
        // END INIT CURRENT TENANT**********************************************************************************/

      }
    ]);
})();
